import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AbstractFieldWriteComponent } from '../base-field/abstract-field-write.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentStoreService } from '../../../services/document-store/document-store.service';
import { HttpError } from '../../../domain/http/http-error.model';
import { Constants } from '../../../commons/constants'
import { flatMap } from 'rxjs/operators';
import { CaseFieldService } from '../../../services';

@Component({
  selector: 'ccd-write-document-field',
  template: require('./write-document-field.html')
})
export class WriteDocumentFieldComponent extends AbstractFieldWriteComponent implements OnInit {
  private uploadedDocument: FormGroup;
  private selectedFile: File;
  @ViewChild('fileInput', {static: true}) fileInput: ElementRef;

  valid = true;
  uploadError: string;
  confirmReplaceResult: string;
  clickInsideTheDocument: boolean

  @HostListener('document:click', ['$event'])
  clickout(event) {
    // Capturing the event of of the associated  ElementRef <input type="file" #fileInpu

    if (this.fileInput.nativeElement.contains(event.target)) {
      this.clickInsideTheDocument = true
    } else {
      this.fileValidations()
    }
  }

  constructor(private documentStore: DocumentStoreService,
              private caseFieldService: CaseFieldService) {
    super();
  }

  ngOnInit() {
    let document = this.caseField.value;

    if (document) {
      this.createDocumentGroup(
        document.id,
        document.name,
      );
    }
  }

  fileValidations () {

    if (this.isAMandatoryComponent()) {

      if ( this.clickInsideTheDocument && this.validateFormUploadedDocument() ) {
        this.displayFileErrors();
      }
    }
  }

  fileValidationsOnTab () {

    if (this.isAMandatoryComponent()) {

      if (this.validateFormUploadedDocument()) {
        this.displayFileErrors();
      }
    }
  }

  private isAMandatoryComponent() {

    return this.caseField.display_context === Constants.MANDATORY;
  }

  private displayFileErrors () {
    this.valid = false;
    this.uploadError = 'File required';
  }

  private  validateFormUploadedDocument():  boolean {
    if (!this.uploadedDocument) {
      return true;
    }

    let validation = !this.uploadedDocument.get('id').valid &&
                     !this.uploadedDocument.get('name').valid;

    return validation;
  }

  fileChangeEvent(fileInput: any) {

    // TODO caching of pre-signed URLs
    // Is there a pre-signed upload URL?
    // Is the pre-signed upload URL still valid?
    // If no -> generate new pre-signed URL

    if (fileInput.target.files[0]) {
      const file = fileInput.target.files[0];
      const metadata = this.getDocumentMetadata(file);

      this.documentStore.newUploadUrl(metadata)
                        .pipe(flatMap(document => this.documentStore.upload(file, document, metadata)))
                        .subscribe(documentId => {
                          this.setDocumentGroup(documentId, file.name);
                          this.valid = true;
                        }, (error: HttpError) => {
                          this.uploadError = this.getErrorMessage(error);
                          this.valid = false;
                        });
    } else {
      this.clearDocumentGroup();
      if (this.isAMandatoryComponent()) {
        this.displayFileErrors();
      }
    }
  }

  private createDocumentGroup(id?: string, name?: string): void {
    const validator = this.caseFieldService.isMandatory(this.caseField) ? Validators.required : undefined;
    this.uploadedDocument = this.registerControl(new FormGroup({
      id: new FormControl(id || '', validator),
      name: new FormControl(name || '', validator),
    }));
  }

  private setDocumentGroup(id: string, name: string): void {
    if (!this.uploadedDocument) {
      this.createDocumentGroup(id, name);
    } else {
      this.uploadedDocument.get('id').setValue(id);
      this.uploadedDocument.get('name').setValue(name);
    }
  }

  private clearDocumentGroup(): void {
    this.setDocumentGroup(null, null);
  }

  private getErrorMessage(error: HttpError): string {
    // Document Management unavailable
    if (0 === error.status || 502 === error.status) {
      return 'Document upload facility is not available at the moment';
    }

    return error.error;
  }

  getUploadedFileName() {
    if (this.uploadedDocument) {
      return this.uploadedDocument.get('document_filename').value;
    } else {
      return undefined;
    }
  }

  getDocumentMetadata(file) {
    return {
      case: this.caseId,
      field: this.fieldMetadata(),
      filename: file.name,
    };
  }

  private fieldMetadata () {
    // FIXME add post-processing to convert ID into usable field path for collection and complex fields
    // eg. defaultProductSyndicateStructure_0_defaultSyndicateStructure_0_startTime ->
    // defaultProductSyndicateStructure[].defaultSyndicateStructure[].startTime
    const fieldId = this.id();
    return fieldId;
  }
}
